export default __webpack_public_path__ + "static/media/unist_logo.f3033e30.svg";